module.exports = __webpack_public_path__ + "f5eb566cc6d458101515d788b72d64d0.svg";